/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_current': {
    width: 16,
    height: 16,
    viewBox: '0 0 35.86 41.09',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path pid="0" d="M17.52 37.91H1V1h31.75v22.45"/><circle pid="1" cx="24.06" cy="29.29" r="6.9" transform="rotate(-45 24.067 29.301)"/><path pid="2" d="M28.94 34.17l5.92 5.92M24.06 25.23v4.06h3.13M7.21 8.34h19.98M7.21 14.34h19.98M7.21 20.34h8.73"/></g></g>'
  }
})
